export enum ErrorsToInclude {
  All = 30, // bitwise of values below,
  Deleted = 2,
  Permission = 4,
  Validation = 8,
  Other = 16
}
